/**
 * liveExitNotice — ce que l'élève lit quand le relevé le fait sortir du live, avant de sortir.
 *
 * L'ancien live (`LiveMainLayout.js`, `useApiStatus(…, errorMessage = true)`) montrait le message du
 * serveur, puis sortait : « Ton accès aux sessions LIVE est suspendu en raison d'un paiement en
 * attente… » sur un 402, « Ce LIVE est accessible uniquement le jour-même… » sur un 403. La famille a
 * un geste à faire : le message est dit, tel que le serveur l'écrit ; la page a le sien s'il manque.
 */
import { type RoomExit } from "../room/roomMachine"

/** La notice d'une sortie : la séance disparue, le paiement en attente, pas le jour du live. */
export type LiveExitNoticeKind = "session_gone" | "payment" | "forbidden"

export function liveExitNotice(
    exit: RoomExit,
    serverMessage: string | null | undefined
): { notice: LiveExitNoticeKind; message: string | null } {
    // Le 404 vient du routage (un modèle introuvable) : son texte n'est pas écrit pour l'élève.
    if (exit === "gone") return { notice: "session_gone", message: null }
    const notice: LiveExitNoticeKind = exit
    const message = typeof serverMessage === "string" && serverMessage.trim() !== "" ? serverMessage.trim() : null
    return { notice, message }
}
